export default "__VITE_ASSET__D3pvgkbq__ 720w";